import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './tab-bar.module.css';
import { ITabBarProps } from './tab-bar.types';

export const TabBar = ({ tabs }: ITabBarProps) => {
  return (
    <div className={styles.tabBar}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.link}
          end={tab.endMatch}
          to={tab.link}
          className={({ isActive }) =>
            `${styles.tab} ${isActive ? styles.tab__active : undefined}`
          }
        >
          {tab.display}
        </NavLink>
      ))}
    </div>
  );
};
